import { runInAction, makeAutoObservable } from "mobx"

import ConvoAPI from '../api/convo';

import { RootStoreType, TransportLayerType, TransportLayerUpdateType } from "./root_store";

type ConvoProps = {
	key: string;
	project: string;
	user: string;
	title: string;
	content: string;
	date_created: string;
	hasUnreadComments: () => boolean;
	updateProps: (attributes: ConvoProps) => void;
};

export class ConvoStore {
	convos = [] as Convo[]
	currentConvoKey = ""
	transport : TransportLayerType
	rootStore
	constructor(rootStore : RootStoreType, transport : TransportLayerType) {
		makeAutoObservable(this, {
			rootStore: false,
			transport: false
		})
		this.rootStore = rootStore
		this.transport = transport
		this.transport.onReceiveUpdate("convos", (data : TransportLayerUpdateType) => {
			runInAction(() => {
				console.log("received update", data);
		 //		this._receiveUpdate(data as ConvoProps);
			})
		})
		this.currentConvoKey = "new";
	}

	getConvoList(projectKey: string) {
		const l = this.convos.slice().filter(c => c.project == projectKey).sort((a, b) => {
			console.log("getConvoList.project: a %o b %o %o", a.project, b.project, projectKey);
			console.log("getConvoList.project: a %o b %o", a, b);
			return a.date_created > b.date_created ? 1 : -1;
		});
		return l;
	}

	receiveUpdate(json: ConvoProps | ConvoProps[]) {
		if(Array.isArray(json)) {
			json.forEach((c) => this._receiveUpdate(c))
		}
	else {
		this._receiveUpdate(json as ConvoProps)
	}
	}

	_receiveUpdate(json : ConvoProps) {
		const convo = this.convos.find((c) => c.key === json.key)
		console.log("_receiveUpdate, json", json);
		if(convo) {
			if(convo.updateProps) {
				convo.updateProps(json)
			}
		} else {
			this.convos.push(new Convo(json))
		}
	}


	loadConvos(projectKey: string) {
		ConvoAPI.loadList(projectKey)
			.then((resp) => {
				const convos = resp.convos;
				// console.log("loaded convos", resp);
				convos.forEach((c : ConvoProps) =>
					runInAction(() => {
						this.receiveUpdate(c);
					})
				);

			})
			.catch((err) => {
				console.error("There was an error loading convos");
				console.error(err);
			});

	}


}
// Domain object Comment.
export class Convo implements ConvoProps {

	key  = "";
	project = "";
	content = "";
	title = "";
	date_created = "";
	user = ""

	constructor(attributes: ConvoProps) {
		makeAutoObservable(this, {
			updateProps: false,
			// store: false,
			// autoSave: false,
			// saveHandler: false,
			// dispose: false
		})
		this.updateProps(attributes);
	}

	updateProps(attributes : ConvoProps) {
		console.log("updateProps with attributes", attributes);
		this.key = attributes.key;
		this.project = attributes.project;
		this.content = attributes.content;
		this.title = attributes.title;
		this.date_created = attributes.date_created;
		this.user = attributes.user;
	}

	hasUnreadComments() {
		return true;
	}

}
